import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/home.vue';

Vue.use(Router);

const routes = [
    {
    path: '/',
    redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
];

const router = new Router({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
    next();
});

export default router;
